import { render, staticRenderFns } from "./SurveyTopic.vue?vue&type=template&id=7ba7c32a&scoped=true&"
import script from "./SurveyTopic.vue?vue&type=script&lang=js&"
export * from "./SurveyTopic.vue?vue&type=script&lang=js&"
import style0 from "./SurveyTopic.vue?vue&type=style&index=0&id=7ba7c32a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba7c32a",
  null
  
)

export default component.exports